import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {AngularFirestore} from "angularfire2/firestore";
import {FavouriteType} from "../types/favourite.type";

@Component({
  selector: 'user-avatar',
  templateUrl: './user-avatar.component.html',
  styleUrls: ['./user-avatar.component.scss']
})
export class UserAvatarComponent implements OnInit {

  @Input() fbId: any;
  @Input() hasLinkWrap: boolean = true;
  @Input() initialsOnHover: boolean = true;
  public user;

  constructor(
    private db: AngularFirestore,
  ){

  }

  ngOnInit() {
    if(this.fbId) {
      this.db.doc('users/' + this.fbId).valueChanges().subscribe(res => {
        this.user = res;
      });
    }
  }

  get getInitials() {
    if (this.user && this.user.first_name && this.user.last_name){
      return this.user.first_name.charAt(0) + this.user.last_name.charAt(0);
    }
  }
}



// WEBPACK FOOTER //
// C:/Development/Private Projects/random-ride/RandomRide/src/app/user-avatar/user-avatar.component.ts